<template>
  <video
    id="video"
    :width="videoWidth"
    :height="videoHeight"
    class="videoTransition centerHorizontalAbsolute"
    autoplay
    playsinlineplaysinline
    muted="true"
    volume="0"
  ></video>
</template>

<script>
export default {
  created() {
    this.isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.isIPad = /iPad/.test(navigator.userAgent) && !window.MSStream;
    this.isMacintosh =
      /Macintosh/.test(navigator.userAgent) && !window.MSStream;
    this.isAndroid = /Android/.test(navigator.userAgent) && !window.MSStream;
    this.isFirefox = /Firefox/.test(navigator.userAgent) && !window.MSStream;
    this.isIOSChrome =
      /Chrome&CriOS/.test(navigator.userAgent) && !window.MSStream;
    this.isIE11 = /Trident/.test(navigator.userAgent) && !window.MSStream;
    this.isEdge = /Edge/.test(navigator.userAgent);
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.isOpera = /Opera/.test(navigator.userAgent) && !window.MSStream;
    this.isChrome = /Chrome/.test(navigator.userAgent) && !window.MSStream;
    if (
      !this.isIOS &&
      !this.isIPad &&
      !this.isSafari &&
      !this.isIE11 &&
      !this.isEdge
    ) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        // Get width and heigth and if the orientation is portrait or landscape
        this.isPortrait = false;
        this.isPortraitTablet = false;
        if (window.outerHeight > window.outerWidth) {
          this.isPortrait = true;
          this.isPortraitTablet = true;
        }
        if (this.isPortrait) {
          this.videoWidth = 240;
          this.videoHeight = 320;
        } else {
          this.videoWidth = 320;
          this.videoHeight = 240;
        }
      } else {
        this.videoWidth = 640;
        this.videoHeight = 480;
      }
      this.EventBus.$on("portrait", () => {
        this.videoWidth = 240;
        this.videoHeight = 320;
      });
      this.EventBus.$on("landscape", () => {
        this.videoWidth = 320;
        this.videoHeight = 240;
      });
      this.EventBus.$on("changeCamera", () => {
        this.enumerateDevices();
      });
    }
  },
  data() {
    return {
      videoWidth: Number,
      videoHeight: Number,
      videoSource: undefined
    };
  },
  mounted() {
    console.log(this.$el);
    this.enumerateDevices();
  },
  methods: {
    enumerateDevices() {
      const $this = this;
      navigator.mediaDevices
        .enumerateDevices()
        .then(devices => {
          let breakForEach = false;
          let videoMode = "user";
          let audioSource = "";

          devices.forEach(device => {
            if (!breakForEach) {
              if (device.kind === "audio" || device.kind === "audioinput") {
                console.log(device.deviceId, device.label || "microphone");
                audioSource = device.deviceId;
              } else if (
                device.kind === "video" ||
                device.kind === "videoinput"
              ) {
                // console.log(device.deviceId, device.label || 'camera');
                // alert(this.videoSource);
                if ($this.videoSource === undefined) {
                  // set front camera first time
                  $this.videoSource = device.deviceId;
                  breakForEach = true;
                  videoMode = "user";
                } else if ($this.videoSource !== undefined) {
                  if ($this.videoSource !== device.deviceId) {
                    // change back camera
                    // alert('backCamera');
                    // alert(this.videoSource);
                    $this.videoSource = device.deviceId;
                    breakForEach = true;
                    videoMode = "environment";
                  }
                }
              } else {
                console.log("Some other kind of source: ", device);
              }
            }
          });

          let constraints = {
            audio: {
              echoCancellation: true
            },
            video: {
              // deviceId: { ideal: device.deviceId },
              facingMode: videoMode,
              width: { exact: 640 },
              height: { exact: 480 }
            }
          };
          // alert(videoMode);

          navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
              this.$el.srcObject = stream;
              // console.log(stream.getVideoTracks()[0].getSettings().deviceId)
              // console.log(stream.getVideoTracks()[0].getSettings().frameRate)
              // console.log(stream.getVideoTracks()[0].getSettings().height)
              // console.log(stream.getVideoTracks()[0].getSettings().width)
              this.$emit("initRecorder", stream);
            })
            .catch(err => {
              console.log(err.name.concat(": ").concat(err.message));
            });
        })
        .catch(err => {
          console.log(err.name.concat(": ").concat(err.message));
        });
      const video = document.querySelector("#video");
    }
  }
};
</script>
